import { convertProductNameToUrl, ProductHit, ProductName } from 'helpers/algolia/map-product';
import { MAIN_CATEGORIES } from 'helpers/constants/categories';
import { sortCategoryLevels } from 'helpers/constants/sortCategoryLevels';
import { Hit } from 'instantsearch.js';

export const productUrl = (productHit: Hit<ProductHit> | any, fallbackLocale: string, localeKey: string) => {
  const lvl0 =
    (productHit?.categories as any)?.[localeKey]?.lvl0 ?? (productHit?.categories as any)?.[fallbackLocale]?.lvl0 ?? [];
  const lvl = sortCategoryLevels(lvl0, MAIN_CATEGORIES);

  const selectedCategory =
    lvl?.find((cat: string) => !cat?.includes('BRANDS')) ?? lvl?.find((cat: string) => cat?.includes('BRANDS'));

  let finalCategory;
  // as of now we are hard coded the "All Products" category need to optimise later

  if (selectedCategory?.split(' > ')[0] === 'All Products') {
    finalCategory = 'products';
  } else {
    finalCategory = !selectedCategory?.split(' > ')?.[0] ? 'products' : selectedCategory?.split(' > ')?.[0];
  }
  const name = getLocalizedField(productHit?.name as ProductName, localeKey, fallbackLocale);
  const slug = getLocalizedField(productHit?.slug as ProductName, localeKey, fallbackLocale);

  return '/' + finalCategory?.toLowerCase()?.replace(' ', '-') + '/' + convertProductNameToUrl(name) + slug + '.html';
};

export const getLocalizedField = (
  field: Record<string, string | undefined> | undefined,
  key: string,
  fallback: string,
) => {
  return field?.[key] ?? field?.[fallback] ?? '';
};
